import { render, staticRenderFns } from "./AssistantDetail.vue?vue&type=template&id=c8463e34&scoped=true&"
import script from "./AssistantDetail.vue?vue&type=script&lang=js&"
export * from "./AssistantDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssistantDetail.vue?vue&type=style&index=0&id=c8463e34&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8463e34",
  null
  
)

export default component.exports